import { storeFcmToken } from 'services/authentication';
import store from 'store';

export const checkAndStoreFcmToken = (): void => {
  const firebaseToken = store.getState().appData.fireBaseToken;

  if (firebaseToken) {
    storeFcmToken(firebaseToken);
  }
};
